<template>
    <div
        ref="page"
        class="editor-text-page editor-light-text-page"
        :class="{ 'is-active': active === page.id }"
        :data-page="page.id"
        @mouseenter="onMouseEnter"
    >
        <template v-for="(id, index) in page.bookpartsList">
            <EditorLightSentence
                v-if="
                    page.bookparts[id].type_part.slug === 'text' &&
                        page.bookparts[id].type_text.slug !== 'book_name' &&
                        page.bookparts[id].type_text.slug !== 'author'
                "
                :key="id"
                class="text__entity"
                :part="page.bookparts[id]"
                :playing-part="playingPart"
                @playPart="onPlayPart"
            />

            <AddSentence
                v-if="
                    page.bookparts[id].type_part.slug === 'text' &&
                        page.bookparts[id].type_text.slug !== 'book_name' &&
                        page.bookparts[id].type_text.slug !== 'author'
                "
                :key="id"
                :bookpart="page.bookparts[id]"
                :last="index === page.bookpartsList.length - 2"
            />
        </template>
        <slot />
    </div>
</template>

<script>
// import Pause from '../Pause/Pause';
import EditorLightSentence from '../EditorLightSentence/EditorLightSentence';
import AddSentence from '../AddSentence/AddSentence.vue';

import { isPause } from '../../utils';

export default {
    name: 'EditorTextPage',
    components: {
        // Pause,
        EditorLightSentence,
        AddSentence
    },
    props: {
        page: {
            type: Object,
            required: true
        },
        active: {
            type: Number,
            required: true
        },
        playingPart: {
            type: Object,
            default: () => undefined
        }
    },
    inject: ['setActivePage'],

    methods: {
        isPause,

        onMouseEnter() {
            if (this.active === this.page.id) return;

            this.setActivePage(this.page.id);
        },

        onPlayPart(event) {
            this.$emit('playPart', event);
        }
    }
};
</script>
